import { Table } from '@devexpress/dx-react-grid-material-ui';
import React from 'react';
import InvoiceIndexStyles from './__styles__/InvoiceIndex.styles';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import TypographyStyles from '../../styles/typography';
import combineStyles from './../../utils/combineStyles';

class TableCell extends React.Component {
  static propTypes = {
    row: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    column: PropTypes.object.isRequired
  };

  _onCellClick = () => {
    const { row, column, history } = this.props;

    // We need to see if they clicked on a link (Create Invoice, Assign Shipment, Shipment #)
    // or just on the row in general to determine what to do.

    // First, get the easy case out of the way.  If it's not the invoice number or shipment number row
    // just go right to the invoice if the invoice number is valued, otherwise to a new invoice
    if (column.name !== 'displayId' && column.name !== 'displayShipmentId') {
      if (row.id) {
        history.push(`/invoices/${row.id}`);
        return;
      } else {
        // TODO - create new invoice.  We'll want to pass in the row data here so it can fill out some fields.
        history.push('/invoices/new');
        return;
      }
    }

    if (column.name === 'displayId') {
      // Clicked on invoice column.  Two cases here are:
      // 1) We have an invoice # - go right to the invoice detail
      // 2) No invoice # so go to Create Invoice
      if (row.id) {
        history.push(`/invoices/${row.id}`);
        return;
      } else {
        // TODO - create new invoice.  We'll want to pass in the row data here so it can fill out some fields.
        history.push(`/invoices/new`);
        return;
      }
    } else {
      // Clicked shipment column.  If we have a shipment number go to
      // that shipment (new window/tab) otherwise open the invoice detail.
      if (row.shipmentId) {
        window.open('/shipments/' + row.shipmentId);
        return;
      } else {
        history.push(`/invoices/${row.id}`);
        return;
      }
    }
  };

  render() {
    const { props } = this;

    // eslint-disable-next-line
    const { column, row, classes, staticContext, ...other } = props;
    switch (column.name) {
      case 'displayId':
        // if (row.id) {
        return <Table.Cell {...other} onClick={this._onCellClick} />;
      case 'displayShipmentId':
        if (row.shipmentId) {
          return (
            <Table.Cell
              {...other}
              classes={{ cell: classes.tableLink }}
              onClick={this._onCellClick}
            />
          );
        }
        return <Table.Cell {...other} onClick={this._onCellClick} />;
      case 'variance':
        if (row.showAsException) {
          return (
            <Table.Cell
              {...other}
              classes={{ cell: classes.exception }}
              onClick={this._onCellClick}
            />
          );
        }
        return <Table.Cell {...other} onClick={this._onCellClick} />;
      default:
        return <Table.Cell {...other} onClick={this._onCellClick} />;
    }
  }
}

export default withRouter(
  withStyles(combineStyles(InvoiceIndexStyles, TypographyStyles))(TableCell)
);
